<h5 class="ops-underline" i18n>Terms and conditions</h5>

<h5 i18n>
  <strong>POWER OF ATTORNEY AND CONSENT TO DATA PROTECTION</strong>
</h5>

<p class="ops-doc-paragraph" i18n>The undersigned</p>

<p class="ops-doc-paragraph" i18n>hereby appoints and authorizes</p>

<p class="ops-doc-paragraph" i18n>
  <strong>Cybera Global AG</strong>, with its registered office in Zurich, registered in the
  Commercial Register under company number CHE-145.311.336 and address at Basteiplatz 7, 8001
  Zurich, www.cybera.io, mail&#64;cybera.io (hereinafter <strong>«CYBERA»</strong>), a company
  specializing in the prosecution and prevention of cybercrime and outsourcing partner therefor,
</p>

<p class="ops-doc-paragraph" i18n>(hereinafter <strong>«Authorized Representative»</strong>),</p>

<p class="ops-doc-paragraph" i18n>
  in order to file a criminal report with the competent law enforcement authorities and financial
  intermediaries at home and abroad regarding the cybercrime incident designated in the
  <strong>CYBERA Scam Response</strong> Service and to file a criminal report accordingly (without
  subsequent legal representation).
</p>

<p class="ops-doc-paragraph" i18n>And issues to the authorized representative for this purpose a</p>

<p class="ops-doc-paragraph" i18n>
  <strong>SPECIAL POWER OF ATTORNEY with corresponding signature authority</strong>
</p>

<p class="ops-doc-paragraph" i18n>
  The undersigned also hereby confirms that he/she is NOT personally aware of the person/group
  responsible for the incident.<br />Important: False reports are punishable by law.
</p>

<p class="ops-doc-paragraph" i18n>
  Furthermore, the<br />
  Consent to Data Protection
</p>

<p class="ops-doc-paragraph" i18n>is granted for the use of:</p>

<ul class="list-inside list-disc">
  <li i18n>
    The following personal data: Personal details/company name, date of birth, address, e-mail,
    telephone number, transaction details, esp. IBAN/crypto/account number (sending account)
    (hereinafter
    <strong>«personal data»</strong>); and
  </li>
  <li i18n>description of the facts; and</li>
  <li i18n>
    any known information about the suspected perpetrator, such as means of contact used, name or
    alias, correspondence, IP addresses and misused account to receive the unlawfully transferred
    assets (recipient account) (hereinafter <strong>«Information»</strong>).
  </li>
</ul>

<p class="ops-doc-paragraph" i18n>
  The Agents shall not use any personal data and information other than those explicitly described
  herein.
</p>

<p class="ops-doc-paragraph" i18n>
  The authorized representatives shall use the personal data and information referred to in the
  aforementioned paragraph exclusively for the following purposes:
</p>

<ul class="list-inside list-disc">
  <li i18n>To recover the amount of the offense;</li>
  <li i18n>to coordinate criminal proceedings; and</li>
  <li i18n>
    To take preventive measures (e.g., security monitoring, maintaining the
    <strong>SCAM Prevention</strong>) against future such incidents.
  </li>
</ul>

<p class="ops-doc-paragraph" i18n>
  For this purpose, the authorized representative is entitled to transmit (electronically and/or by
  post) the relevant data to responsible recipients in Germany and abroad (esp. financial
  institutions) (so-called
  <strong>CYBERA Scam Response</strong>) as well as to collect and process the information in a
  database of suspicious accounts, perpetrator information and other suspicious elements (so-called
  <strong>SCAM Prevention</strong>).
</p>

<p class="ops-doc-paragraph" i18n>
  Outsourcing partners (esp. bank, possibly law enforcement agency) are hereby granted the explicit
  consent to disclose all personal data and information mentioned in the aforementioned paragraph to
  CYBERA for the aforementioned purpose. For this purpose, the bank is released from the banking
  secrecy for the purposes mentioned in the aforementioned paragraph; the police authority is
  released from the official secrecy for the purposes mentioned in the aforementioned paragraph.
</p>

<p class="ops-doc-paragraph" i18n>
  For the aforementioned purposes of use, the authorized representatives are also entitled to
  disclose the personal data and information, also in the form of the so-called
  <strong>SCAM Prevention</strong> database, to selected third parties: such as law enforcement
  authorities, other financial institutions/financial intermediaries and outsourcing partners. These
  selected third parties may be located abroad, where data protection legislation equivalent to that
  in Switzerland is lacking. However, CYBERA takes appropriate measures for an equivalent protection
  in accordance with the European and Swiss data protection legislation according to its data
  protection policy. Further information on data processing by CYBERA can also be found in the data
  protection policy.
</p>

<p class="ops-doc-paragraph" i18n>
  The authorized representatives act to the best of their knowledge and belief based on this power
  of attorney and consent. All warranties and liability are excluded to the extent permitted by law.
</p>

<p class="ops-doc-paragraph" i18n>
  The Authorized Representative is authorized to appoint a sub-authorized representative on its
  behalf and under its responsibility to exercise the powers under this Power of Attorney.
</p>

<p class="ops-doc-paragraph" i18n>
  <strong>This power of attorney and consent may be revoked at any time.</strong>
  However, the revocation of the consent shall not affect the lawfulness of the processing based on
  the consent prior to the revocation.
</p>

<p class="ops-doc-paragraph" i18n>
  Substantive Swiss law is applicable with regard to the present contractual relationship. The place
  of jurisdiction for disputes shall be the registered office of the Authorized Representative.
</p>
